module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-simple-analytics/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"genesis-cu","short_name":"Genesis CU","start_url":"/","background_color":"#FFFFFF","theme_color":"#A39161","display":"minimal-ui","icon":"static/images/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"847ece3c6fbb02ab5955850c0975e682"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
